export default __webpack_public_path__ + "static/media/Theatre-Room.cce8ca30.webp";